import DepartmentDto from '../Departments/DepartmentDto';
import AddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import NoteDto from '@/models/Notes/NoteDto';
import BaseCompanyScopeEntityDto from '@/models/Shared/BaseCompanyScopeEntityDto';
import GeoPoint from '@/models/Shared/GeoPoint';
import IAddressLine from '@/models/Shared/IAddressLine';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import RateCardDto from '../RateCards/RateCardDto';

export default class LocationDto extends BaseCompanyScopeEntityDto implements IAddressLine {
    sequenceNumber = 0;
    status = 0;
    registeredName = '';    
    brandName = '';
    locationTypeId = '';
    locationType: LocationTypeDto = new LocationTypeDto();
    emailAddress = '';
    phoneNumber = '';
    taxNumber = '';    
    registrationNumber = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    parkingInstructions = '';
    arrivalInstructions = '';
    website = '';
    biography = '';
    avatar = '';
    healthAndSafetyAssessment = '';
    lastHealthAndSafetyAssessmentAt: Date;
    rateCardId = '';
    rateCard: RateCardDto = new RateCardDto();
    externalAccountingSystemId = '';
    externalPayrollSystemId = '';
    departments: DepartmentDto[] = []
    contactLocations: ContactLocationDto[] = []
}